module.exports = __webpack_public_path__ + "img/email1.2c4f8e17.svg";